export default class Toggle {
	constructor( element ) {
		this.element = element;
		this._offEvents = [];
		this._onEvents = [];

		if ( !this.element.hasOwnProperty( 'toggle' ) ) {
			this.initEvents();
		}
	}

	onToggleOn( callback ) {
		this._onEvents.push( callback );

		return this;
	}

	onToggleOff( callback ) {
		this._offEvents.push( callback );

		return this;
	}

	initEvents() {
		this.element.addEventListener( 'click', e => {
			e.preventDefault();
			this.toggle();
		} );

		this.element.toggle = this;
	}

	isOn() {
		return this.element.classList.contains( '-on' );
	}

	toggle() {
		if ( this.isOn() ) {
			this.toggleOff();
		} else {
			this.toggleOn();
		}
	}

	toggleOn() {
		this.element.classList.add( '-on' );
		this.element.dispatchEvent( new CustomEvent( 'toggleOn' ) );
		this._onEvents.forEach( c => {
			c( this );
		} );
	}

	toggleOff() {
		this.element.classList.remove( '-on' );
		this.element.dispatchEvent( new CustomEvent( 'toggleOff' ) );
		this._offEvents.forEach( c => {
			c( this );
		} );
	}

}